<template>
  <div v-if="project?.donation_procedure && block.isShowed('button')">
    <project-button
      class="btn__size--full-12"
      :project="project"
      :is-preview="is_preview"
    >
      <template #ongoing>
        {{ translate(block.getText('ongoing')) || t('literal.donate') }}
      </template>

      <template #reached>
        {{ translate(block.getText('limited_to_one_contribution')) || t('literal.already_contributed') }}
      </template>

      <template #not_started>
        {{ translate(block.getText('not_started_yet')) || t('project_page.btn_donate_not_started_yet') }}
      </template>

      <template #ended>
        {{ translate(block.getText('finished')) || t('project_page.btn_donate_finished') }}
      </template>
    </project-button>

    <p
      class="info align--center color--lg margin__t--6"
      v-if="!project.is_started"
    >
      {{ t('plural.starts_in_x_day', { daysNumber: days }, days) }}
    </p>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { differenceInCalendarDays } from 'date-fns'
import { get as _get } from 'lodash'

const ProjectButton = defineAsyncComponent(() => import('@/components/modules/project/ProjectButton'))

defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { t, translate } = useI18n()

const objects = inject('objects', {})
const is_preview = inject('preview', false)

const project = computed(() => _get(objects.value, 'project'))
const startDate = computed(() => project.value?.start_date)

const days = computed(() => startDate.value ? differenceInCalendarDays(new Date(startDate.value), new Date()) : 0)
</script>

<style lang="scss" scoped>
.info {
  font-size: rem(14px);
}
</style>